/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Inject, ViewEncapsulation } from '@angular/core';
import {
  MatLegacyDialog as MatDialog,
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
} from '@angular/material/legacy-dialog';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { AuthService } from 'src/app/service/auth.service';
import { NewsletterApiService } from 'src/app/shared/services/customer-api/newsletter-api.service';
import { Router } from '@angular/router';
import { RoutingService } from 'src/app/service/routing.service';

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'app-newsletter-send',
  templateUrl: './newsletter-send.component.html',
  styleUrls: ['./newsletter-send.component.scss'],
})
export class NewsletterSendComponent {
  summary: any;
  sendToAll: any;
  newsletter: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    public snackBar: MatSnackBar,
    public auth: AuthService,
    private newsletterApi: NewsletterApiService,
    private router: Router,
    public routing: RoutingService,
  ) {
    this.sendToAll = true;
    this.newsletter = this.data.newsletter;
  }

  onSubmit() {
    const newsletter = JSON.parse(JSON.stringify(this.newsletter));

    this.newsletterApi.editNewsletter(newsletter).subscribe(
      (result) => {
        if (result && result.uid) {
          const data = {
            uid: result.uid,
            send_to_all: this.sendToAll,
          };
          if (this.summary) {
            data['summary'] = this.summary;
          }
          this.newsletterApi.generateNewsletter(data).subscribe(() => {
            this.snackBar.open(
              'Newsletter scheduled for sending, it may take a while to deliver.',
              'OK',
              { duration: 5000 },
            );
            this.dialog.closeAll();
          });
        }
        let url = '/cockpit/newsletter';
        if (this.routing.isPreview()) {
          url = '/cockpit/newsletter/preview';
        }
        this.router.navigate([url], {
          queryParams: { id: result.uid, rdn: Math.random() },
          queryParamsHandling: 'merge',
          replaceUrl: true,
        });
      },
      (error) => {
        this.dialog.closeAll();
        alert('Error: unable to save newsletter. ' + error);
      },
    );
  }
}
